const mixin = {
  props: {
    noDataText: {
      type: String,
      default: "Não há registros a serem exibidos"
    }
  },
  methods: {
    /**
     * Limpa um objeto para a forma mais inicial dele, valores string e number são setados para null,
     * Arrays são setados para vazio e objetos são limpos recursivamente.
     * @example this.$clearFilters(this.form.filters);
     * @param {*} obj
     * @returns {*}
     */
    $clearFilters(obj) {
      for (let key in obj) {
        if (obj[key] !== null && typeof obj[key] === 'object' && !Array.isArray(obj[key])) {
          this.$clearFilters(obj[key]);
        } else if (Array.isArray(obj[key])) {
          obj[key] = [];
        } else {
          obj[key] = null;
        }
      }
      return obj;
    }
  },
};

export default mixin;
